type CustomerVersion = 'ronik' | 'zxy' | 'rws' | 'rijksvastgoed' | 'hyperplane' | 'intures' | 'utrecht' | 'aquasmart' | 'amsterdam' | 'rotterdam';

interface IZxySettings {
    customerVersion: CustomerVersion;
}

declare global {
    interface IWindow extends Window {
        zxySettings?: IZxySettings;
    }
}

const customWindow = window as IWindow;

export function isCustomerVersion(customerVersion: CustomerVersion | CustomerVersion[]) {
    const currentVersion: CustomerVersion | undefined = customWindow.zxySettings?.customerVersion;

    if (currentVersion) {
        if (Array.isArray(customerVersion)) {
            return customerVersion.includes(currentVersion);
        }
        return customerVersion === currentVersion;
    }

    return false;
}
